import axios from 'axios';

const BASE_URL = 'https://apps.swarcklabs.com/api/balance-sheet';
// const BASE_URL = 'http://localhost:8082/api/balance-sheet';

/**
 * Upload an Excel file to the balance sheet API.
 * @param {File} file - The file to upload.
 * @returns {Promise} Axios response promise.
 */
export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append('file', file);

  return axios.post(`${BASE_URL}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/**
 * Submit table data to generate and download an Excel file.
 * @param {Object} payload - The table data payload.
 * @returns {Promise} Axios response promise (responseType: 'blob').
 */
export const submitTableData = (payload) => {
  return axios.post(`${BASE_URL}/generate`, payload, {
    headers: { 'Content-Type': 'application/json' },
    responseType: 'blob',
  });
};
